<template>
  <div :class="!showSlideBar ? 'slideOutLeftAni slideBar' : 'slideBar'">
    <span class="abs block people"></span>
    <span class="abs block cursor font_store" @click="gotoStore"></span>
    <span class="abs block cursor circle" @click="gotoStore"></span>
    <span class="abs block cursor close" @click="closeDialog"></span>
  </div>
</template>

<script>
export default {
  name: 'SliderBar',
  props: {
    options: Object,
  },
  data(){
    return {
      showSlideBar: true,
    }
  },
  methods: {
    closeDialog(){
      this.showSlideBar = !this.showSlideBar;
    },
    gotoStore(){
      this.$router.push('/gameStoreCenter');
    }
  }
}
</script>

<style lang="stylus" scoped>
.slideBar
  width 2.37rem
  height 3.18rem
  position fixed
  top 3.43rem
  right .03rem
  z-index 9
  .people
    width 2.36rem
    height 2.42rem
    right 0
    top 0
    background url("~@mbAssets/imgs_m/sliderBar/role.png") no-repeat
    background-size 100% 100%
    animation upDown 1.5s linear infinite
  .font_store
    width 2.45rem
    height 1.05rem
    left calc(50% - 1.225rem)
    top 1.81rem
    z-index: 1
    background url("~@mbAssets/imgs_m/sliderBar/no_fire_center.png") no-repeat
    background-size 100% 100%
  .circle
    width 2.21rem
    height 1.97rem
    left calc(50% - 1.105rem)
    top .51rem
    background url("~@mbAssets/imgs_m/sliderBar/fire_circle.png") no-repeat
    background-size 100% 100%
    animation rotate360 3s linear infinite
  .close
    width .64rem
    height .6rem
    left calc(50% - .32rem)
    bottom -.05rem
    /*background url("~@mbAssets/imgs_m/sliderBar/close.png") no-repeat*/
    background url("~@pcAssets/imgs/slideBar/close.png") no-repeat
    background-size 100% 100%
    &:hover{
      transition transform .3s linear
      transform scale(1.1)
    }

</style>
